import { Directive } from '@angular/core';

@Directive({
  selector: '[editButton]'
})
export class EditButtonDirective {}
